<template>
        <transition enter-active-class="transition-all duration-1000 ease-out-quad"
            leave-active-class="transition-all duration-500 ease-in-quad"
            enter-class="opacity-0 scale-70"
            enter-to-class="opacity-100 scale-100"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-70">

            <slot/>

        </transition>
</template>

<script>
export default {
    name: "MyTransition"
}
</script>

<style scoped>

</style>
